import { AxiosError } from 'axios';
import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteUser } from '../api/users';
import { queryKeys } from '../lib/react-query';

const useDeleteUser = () => {
  const [errorMessage, setError] = useState('');
  const queryClient = useQueryClient();

  const deleteMutation = useMutation({
    mutationFn: (userId: number) => deleteUser(userId),
    onSuccess: () => {
      setError('');
      queryClient.invalidateQueries({ queryKey: queryKeys.users.all });
    },
  });

  const deleteUserWithId = async (userId: number): Promise<number> => {
    setError('');

    try {
      await deleteMutation.mutateAsync(userId);
      return 204;
    } catch (e) {
      if (e instanceof AxiosError && e.response) {
        if (e.response.status === 403) {
          setError(
            'Nie masz wystarczających uprawnień do usuwania użytkowników'
          );
        } else {
          setError('Wystąpił błąd podczas usuwania użytkownika');
        }

        return e.response.status;
      } else {
        return 500;
      }
    }
  };

  return {
    deleteUserWithId,
    errorMessage,
    setError,
    isPending: deleteMutation.isPending,
  };
};

export default useDeleteUser;
